'use client';
import * as React from 'react';
import { forwardRef } from 'react';
import cn from 'clsx';
import styles from './radio.module.scss.js';
import { MtsDsRadioIcon } from './radio-icon.js';

/**
 * Компонент Radio
 */
const Radio = /*#__PURE__*/forwardRef(({
  disable,
  checked,
  invalid,
  size,
  name,
  value,
  onChange,
  ariaLabel,
  ariaLabelledby,
  ariaDescription,
  ariaDescribedby
}, ref) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles['mtsds-radio'], styles[`mtsds-radio--size-${size}`], invalid && styles['mtsds-radio--invalid'])
  }, /*#__PURE__*/React.createElement("input", {
    className: styles['mtsds-radio__input'],
    type: "radio",
    name: name,
    value: value,
    onChange: onChange,
    checked: checked,
    ref: ref,
    disabled: disable,
    "aria-disabled": disable,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby
    // eslint-disable-next-line jsx-a11y/aria-props
    ,
    "aria-description": ariaDescription,
    "aria-describedby": ariaDescribedby
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['mtsds-radio__wrapper'],
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(MtsDsRadioIcon, {
    size: size
  })));
});
Radio.defaultProps = {
  name: undefined,
  value: undefined,
  onChange: undefined,
  checked: undefined,
  invalid: false,
  disable: false
};

export { Radio as MtsDsRadio, Radio };
